<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <path d="M12,6.663c1.015,0.001,1.837,0.823,1.836,1.838s-0.823,1.837-1.838,1.836c-1.014-0.001-1.836-0.823-1.836-1.837
     c0-1.015,0.822-1.837,1.837-1.837C11.999,6.663,12,6.663,12,6.663 M12,14.538c2.6,0,5.338,1.278,5.338,1.838v0.963H6.663v-0.963
     C6.663,15.816,9.402,14.538,12,14.538 M12,5c-1.933,0-3.5,1.567-3.5,3.5S10.067,12,12,12s3.5-1.567,3.5-3.5S13.933,5,12,5z
      M12,12.875c-2.336,0-7,1.173-7,3.5V19h14v-2.625C19,14.047,14.336,12.875,12,12.875z"/>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'user'
}
</script>
